import cx from "classnames";

import LinkButton from "common/components/LinkButton";
import Image from "common/components/Image";
import { Optional } from "common/utils/types";
import { useIsHdEnabled } from "common/contexts/UIContext";

import { useClinic } from "client/clinics/hooks";
import { urls } from "client/routes";

import styles from "../../styles/Logo.module.less";

type LogoProps = {
  isWhite?: boolean;
  storefrontThemeLogo?: Optional<string>;
};

const Logo = ({ isWhite = false, storefrontThemeLogo }: LogoProps) => {
  const { logo: defaultLogo, display_name: name } = useClinic();
  const isHdEnabled = useIsHdEnabled();

  const { logo, isThemeLogo } = storefrontThemeLogo
    ? { logo: storefrontThemeLogo, isThemeLogo: true }
    : { logo: defaultLogo, isThemeLogo: false };

  const renderContent = () => {
    if (logo) {
      return <Image src={logo} alt={name} className={styles.logo} />;
    }
    return (
      <div className={styles.textLogo}>
        <h5 className={styles.title}>{name}</h5>
      </div>
    );
  };

  // When HD is disabled, render logo without link
  if (!isHdEnabled) {
    return (
      <div className={cx(styles.container, isWhite && !isThemeLogo && styles.white)}>
        {renderContent()}
      </div>
    );
  }

  return (
    <LinkButton
      // if it's supposed to be a white logo and we're using a default or text logo, let's white-ify the logo
      className={cx(styles.container, isWhite && !isThemeLogo && styles.white)}
      dest={urls.home.root()}
    >
      {renderContent()}
    </LinkButton>
  );
};

export default Logo;
